import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const inputStyle = {
  borderRadius: 4,
  fontSize: 'calc(6px + 0.4vw)',
  padding: '8px 12px',
  fontFamily: 'Open Sans',
  backgroundColor: '#F4F3F4',
  color: 'rgba(0, 0, 0, 0.38)',
  border: 'none',
  width: 'calc(100% - 24px)',
};

const headerStyle = {
  fontFamily: 'Open Sans',
  color: '#858585',
  fontSize: 'calc(6px + 0.3vw)',
  textAlign: 'left',
};

const NoAvailablePackages = ({ data, handleSelectPackage, selectedPackage, intl }) => {
  if (!data?.candidatePackages) return null;

  const items = data.candidatePackages.map((item, index) => (
    <div key={index} className="grid grid-cols-12 gap-4 items-center">
      {/* Left Column: Radio + Package Name */}
      <div className="col-span-6 flex items-center">
        <div className="w-[16.666%] flex items-center justify-start">
          <input
            type="radio"
            name="package-selection"
            checked={selectedPackage === item.id.toString()}
            onChange={handleSelectPackage}
            value={item.id.toString()}
            className="w-4 h-4 text-[#4055b3] focus:ring-[#4055b3] border-[#ced4da] pointer-events-auto"
          />
        </div>
        <div className="w-[83.333%]">
          <input
            type="text"
            value={item.name}
            readOnly
            disabled
            style={inputStyle}
          />
        </div>
      </div>

      {/* Right Column: Area */}
      <div className="col-span-6">
        <input
          type="text"
          value={`${item.standardMeters?.formattedValue || ''} créditos`}
          readOnly
          disabled
          style={inputStyle}
        />
      </div>
    </div>
  ));

  return (
    <div className="w-full mt-4 flex flex-col gap-2">
      {/* Header Row */}
      <div className="grid grid-cols-12 gap-4 mb-1">
        <div className="col-span-6">
          <div className="text-[calc(6px+0.3vw)] text-[#858585] font-['Open_Sans']" style={headerStyle}>
            <FormattedMessage id="package" />
          </div>
        </div>
        <div className="col-span-6">
          <div className="text-[calc(6px+0.3vw)] text-[#858585] font-['Open_Sans']" style={headerStyle}>
            <FormattedMessage id="area" />
          </div>
        </div>
      </div>

      {/* List Items */}
      <div className="flex flex-col gap-2">
        {items}

        {/* Individual Inspection */}
        <div className="grid grid-cols-12 gap-4 items-center">
          <div className="col-span-6 flex items-center">
            <div className="w-[16.666%] flex items-center justify-start">
              <input
                type="radio"
                name="package-selection"
                checked={selectedPackage === ''}
                onChange={handleSelectPackage}
                value=""
                data-cy="select-package"
                className="w-4 h-4 text-[#4055b3] focus:ring-[#4055b3] border-[#ced4da] pointer-events-auto"
              />
            </div>
            <div className="w-[83.333%]">
              <input
                type="text"
                value={intl.formatMessage({ id: 'INDIVIDUAL_INSPECTION' })}
                readOnly
                disabled
                style={inputStyle}
              />
            </div>
          </div>

          {data.monetaryPrice?.standardMeters?.formattedValue && (
            <div className="col-span-6">
              <input
                type="text"
                value={`${data.monetaryPrice.standardMeters.formattedValue} créditos`}
                readOnly
                disabled
                style={inputStyle}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

NoAvailablePackages.propTypes = {
  handleSelectPackage: PropTypes.func.isRequired,
  selectedPackage: PropTypes.string,
  data: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(NoAvailablePackages);
